module.exports = __webpack_public_path__ + "img/14-25-165.1008766e.png";